export default __webpack_public_path__ + "static/media/nurse.7bbc23fd.jpg";